import React from 'react'
import { Link } from 'react-router-dom'
import { Font, Footer } from 'components'
import cx from 'classnames'
import styles from './styles.module.scss'

const SweepstakesPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <Font
          type="heading"
          weight="bold"
          className={cx(styles.title, 'mb-32')}
        >
          Recon Food Summer of Starbucks Sweepstakes
        </Font>

        <Font type="bodyLato" className="mb-32">
          Before submitting an entry, please review the official sweepstakes
          rules located{' '}
          <Link className={styles.link} to="/sweepstakes/rules">
            here
          </Link>
          . By submitting an entry you expressly agree to the terms of the
          official rules.
        </Font>

        <Font type="bodyLato" weight="bold" className="mb-16">
          How to Enter:
        </Font>
        <Font type="bodyLato" className="mb-16">
          The Sweepstakes will accept entries between the Sweepstakes Start Date
          June 14, 2021 and the Sweepstakes End Date June 21, 2021 (the
          “Sweepstakes Period”). You may enter the sweepstakes in two ways: (1)
          post a picture of a starbucks drink on Recon Food with the
          #mystarbucks; or (2) mail a submission containing your name, address
          and telephone number to: ATTN Sweepstakes Entry, 3019 Wilshire
          Boulevard, Unit 317, Santa Monica, California, 90403.
        </Font>

        <Font type="bodyLato" className="mb-16">
          One entry per participant.
        </Font>
        <Font type="bodyLato" className="mb-16">
          Mailed Submissions will be dated as submissions on the date they are
          received and will be discarded if received after the Sweepstakes End
          Date.
        </Font>
        <Font type="bodyLato" className="mb-16">
          No purchase is necessary to enter, a purchase does not increase your
          odds of winning.
        </Font>
        <Font type="bodyLato" className="mb-32">
          The Sweepstakes is open only to legal permanent residents of: the
          fifty (50) United States and the District of Columbia (excluding,
          without limitation, Puerto Rico, other U.S. territories and
          possessions, and where prohibited by law), who are 18 years of age or
          older or the age of majority in their state of residence. Additional
          exclusions in Official Rules.
        </Font>

        <Font type="bodyLato" weight="bold" className="mb-16">
          How to Win:
        </Font>
        <Font type="bodyLato" className="mb-32">
          One (1) winner will be selected in a random drawing on June 22nd,
          2022. Winners are subject to eligibility requirements in official
          rules. Your odds of winning vary depending on the number of entries
          received.
        </Font>

        <Font type="bodyLato" weight="bold" className="mb-16">
          What you Win:
        </Font>

        <Font type="bodyLato" className="mb-16">
          One (1) winner will receive a $10 Postmates gift card.
        </Font>
        <Font type="bodyLato" className="mb-16">
          Please see official rules for full prize details.
        </Font>
        <Font type="bodyLato" className="mb-32">
          Winners will be notified by June 25th and announced on Recon Food by
          June 25th.
        </Font>

        <Font type="bodyLato" className="mb-16">
          Good luck!
        </Font>
        <Font type="bodyLato" className="mb-16">
          <b>Questions?</b> Send them to{' '}
          <a
            className={styles.link}
            href="https://www.instagram.com/getreconfood/"
          >
            @getreconfood
          </a>
          .
        </Font>

        <div className="mt-32">
          <Footer alightCenter hideRules />
        </div>
      </div>
    </div>
  )
}

export default SweepstakesPage
